import { render, staticRenderFns } from "./LanguageSelection.vue?vue&type=template&id=e3625582&scoped=true"
import script from "./LanguageSelection.vue?vue&type=script&lang=js"
export * from "./LanguageSelection.vue?vue&type=script&lang=js"
import style0 from "./LanguageSelection.vue?vue&type=style&index=0&id=e3625582&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3625582",
  null
  
)

export default component.exports